import config_ext from '../../config_ext.js';

// config_ext.js prod: the native linux hosts (www calls api2). Tags link
// to MediaServe's public url
const prod = {
    env: 'PROD',
    url: {
        API_URL: config_ext.back?.api?.url,
        BannerService: config_ext.back?.media?.url,
        MediaService: config_ext.back?.preview?.url,
    }
};
const pre = {
    env: 'PRE',
    url: {
        API_URL: "http://newapi.bstage.io", 
        BannerService: "http://newapi.bstage.io",
        MediaService: "http://newapi.bstage.io",
    }
};
const local_22 = {
    env: 'DEV_TEST',
    url: {
        API_URL: "http://backstage_api.b-soft.co.il", //  10.22
        BannerService: "http://backstage_api.b-soft.co.il",
        MediaService: "http://backstage_api.b-soft.co.il",
    }
};

const dev = {
    env: 'DEV',
    url: {
        API_URL: "http://localhost:51509", 
        BannerService: "http://localhost:51509",
        MediaService: "http://localhost:51509",
    }
};
const getConfig = () => {

    // explicit backend for local / non-prod builds, set at build time (prod
    // builds: the legacy hostnames below, else config_ext's prod)
    if(!config_ext.is_prod && config_ext.back?.api?.url){
        const url = config_ext.back.api.url;
        return { env: 'LOCAL', url: { API_URL: url, BannerService: url, MediaService: url } };
    }
    if(import.meta.env.PROD){
        if(window.location.href.toLowerCase().indexOf('backstageapp.b-soft.co.il') >= 0){
            return local_22;
        }
        if(window.location.href.toLowerCase().indexOf('new.bstage.io') >= 0){
            return pre;
        }
        return prod;
    }
    return dev;
};

export const constConfig = getConfig();
// back_app (src/back/app/bs.js), config_ext.js back.app.is_bs: the endpoints
// ported from the C# api are called there instead of API_URL's asmx
export const back_app_url = config_ext.back?.app?.url;
export const is_bs_app = !!config_ext.back?.app?.is_bs;
